import { render, staticRenderFns } from "./ListLiquidation.vue?vue&type=template&id=5765b7d1"
import script from "./ListLiquidation.vue?vue&type=script&lang=js"
export * from "./ListLiquidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports